var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._b({attrs:{"value":_vm.internalValue},on:{"input":_vm.onInput}},'el-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }